// Shared rental pricing helpers for Plumme's script-loaded UI.
(function () {
  const toNumber = (value, fallback = 0) => {
    const parsed = Number(String(value ?? '').replace(/\s/g, '').replace(',', '.'));
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const clampPercent = (value, fallback) => Math.max(0, Math.min(100, toNumber(value, fallback)));

  const normalizeRentalPricing = (pricing) => {
    if (!pricing || pricing.enabled === false) return { enabled: false, dayRates: [] };
    const rawRates = Array.isArray(pricing.dayRates) && pricing.dayRates.length
      ? pricing.dayRates
      : [
          { fromDay: 1, percent: 100 },
          { fromDay: 2, percent: pricing.day2Percent ?? 50 },
          { fromDay: 3, percent: pricing.day3PlusPercent ?? 25 },
        ];
    const byDay = new Map();
    rawRates.forEach((rate) => {
      const fromDay = Math.max(1, Math.round(toNumber(rate.fromDay, 1)));
      byDay.set(fromDay, { fromDay, percent: clampPercent(rate.percent, fromDay === 1 ? 100 : 0) });
    });
    byDay.set(1, { fromDay: 1, percent: 100 });
    return {
      enabled: true,
      dayRates: [...byDay.values()].sort((a, b) => a.fromDay - b.fromDay),
    };
  };

  const rentalDays = (from, to) => {
    const start = new Date(`${String(from || '').slice(0, 10)}T00:00:00`);
    const end = new Date(`${String(to || from || '').slice(0, 10)}T00:00:00`);
    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return 1;
    if (end < start) return 1;
    return Math.round((end.getTime() - start.getTime()) / 86400000) + 1;
  };

  const rentalDayPercent = (dayRates, day) => {
    const normalized = normalizeRentalPricing({ enabled: true, dayRates }).dayRates;
    let match = normalized[0] || { percent: 100 };
    normalized.forEach((rate) => {
      if (rate.fromDay <= day) match = rate;
    });
    return match.percent;
  };

  const rentalMultiplier = (pricing, days) => {
    const normalized = normalizeRentalPricing(pricing);
    if (!normalized.enabled) return 1;
    const count = Math.max(1, Math.round(toNumber(days, 1)));
    let total = 0;
    for (let day = 1; day <= count; day += 1) {
      total += rentalDayPercent(normalized.dayRates, day) / 100;
    }
    return total;
  };

  const rentalLineBase = (line) => {
    const qty = toNumber(line?.quantity ?? line?.qty, 1);
    const unitPrice = toNumber(line?.unitPrice ?? line?.price, 0);
    const pricing = line?.rentalPricingApplied || line?.rentalPricing;
    const period = line?.rentalPeriod || {};
    const from = period.from || line?.rentalFrom || line?.rentalStart || line?.subStart;
    const to = period.to || line?.rentalTo || line?.rentalEnd || line?.subEnd || from;
    const kind = line?.productKind || line?.kind;
    const type = line?.productType || line?.type;
    if (!pricing?.enabled || (kind !== 'rental' && type !== 'Utleie')) return qty * unitPrice;
    return qty * unitPrice * rentalMultiplier(pricing, rentalDays(from, to));
  };

  const describeRentalPricing = (pricing) => {
    const normalized = normalizeRentalPricing(pricing);
    if (!normalized.enabled) return '';
    return normalized.dayRates
      .map((rate, index) => {
        const next = normalized.dayRates[index + 1];
        const label = next ? `dag ${rate.fromDay}-${next.fromDay - 1}` : `dag ${rate.fromDay}+`;
        return `${label}: ${rate.percent}%`;
      })
      .join(', ');
  };

  const api = {
    normalizeRentalPricing,
    rentalDays,
    rentalMultiplier,
    rentalLineBase,
    describeRentalPricing,
  };
  if (typeof window !== 'undefined') window.PlummeRentalPricing = api;
  if (typeof globalThis !== 'undefined') globalThis.PlummeRentalPricing = api;
})();
